// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Ex","categoryName":"Fx","categoryImage":"Gx","categoryContent":"Hx","bottomAligned":"Ix"};